import { Reveal, SectionTag } from "@/components/Reveal";

const SECTIONS = [
  {
    n: "01",
    title: "Generelt",
    body: "GEKKOFUEL drives af Frederik & Sesilie, Fælleden 16, 7190 Billund. Disse betingelser gælder for alle køb på siden. Levende dyr sælges som privat hobbyopdræt — ikke via virksomheden.",
  },
  {
    n: "02",
    title: "Betaling",
    body: "Betaling sker sikkert via Stripe med betalingskort eller MobilePay. Alle priser er i danske kroner (DKK) inklusive moms. Beløbet trækkes, når ordren gennemføres.",
  },
  {
    n: "03",
    title: "Levering og afhentning",
    body: "Afhentning sker på Fælleden 16, 7190 Billund efter aftale. Personlig levering tilbydes for 300 kr inden for 120 km fra Billund. Produkter sendes med post til en vægtbaseret pris — gratis ved køb over 499 kr (op til 10 kg). Terrarier og baggrunde kan kun afhentes.",
  },
  {
    n: "04",
    title: "Levende dyr",
    body: "Kronegekkoer sælges som privat hobbyopdræt. Vi garanterer, at dyret er rask og spiseklar ved overtagelsen. Levende dyr omfattes ikke af forbrugerlovens fortrydelsesret og tages ikke retur.",
  },
  {
    n: "05",
    title: "Fortrydelsesret",
    body: "Produkter kan fortrydes inden for 14 dage i ubrugt stand. Levende dyr, specialbyggede baggrunde og jord/foder med brudt emballage er undtaget fortrydelsesretten.",
  },
  {
    n: "06",
    title: "Reklamation",
    body: "Der gives 24 måneders reklamationsret på produkter efter købeloven. Kontakt os med billeder og ordrenummer, så finder vi en løsning hurtigt.",
  },
  {
    n: "07",
    title: "Persondata",
    body: "Vi gemmer kun de oplysninger, der er nødvendige for at gennemføre din ordre (navn, e-mail, telefon og adresse). Oplysninger deles aldrig med tredjepart og kan til enhver tid slettes ved henvendelse.",
  },
];

export default function HandelsbetingelserPage() {
  return (
    <div data-testid="handelsbetingelser-page" className="px-6 pb-24 pt-36 lg:px-16 lg:pb-36">
      <Reveal>
        <SectionTag index="08" label="Handelsbetingelser" />
        <h1 className="mt-6 max-w-3xl font-serif text-4xl tracking-tight text-cream sm:text-5xl">
          Handelsbetingelser
        </h1>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-sage sm:text-lg">
          Gældende for alle køb hos GEKKOFUEL. Læs dem gerne igennem — og skriv til os,
          hvis noget er uklart.
        </p>
      </Reveal>

      <div className="mt-16">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.05}>
            <div className="grid grid-cols-1 gap-6 border-t border-white/10 py-12 lg:grid-cols-12">
              <span className="font-mono text-xs tracking-[0.25em] text-forest lg:col-span-2">
                {s.n}
              </span>
              <h2 className="font-serif text-3xl italic tracking-tight text-cream lg:col-span-4">
                {s.title}
              </h2>
              <p className="max-w-xl text-base leading-relaxed text-sage lg:col-span-6">
                {s.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
